import {Expose, Type} from 'class-transformer';
import {UserApiModel} from './user.api-model';
import {AbstractApiModel} from './abstract.api.model';
import {MediaObjectApiModel} from './media-object.api-model';
import {EventApiModel} from './event.api.model';
import {ReactionApiModel} from './reaction.api.model';
import {ProjectApiModel} from "./project.api-model";
import {ProjectCollaborationApiModel} from "./collaboration/project-collaboration.api-model";
import {ShareRefApiModel} from './share-ref.api-model';
import {ShareCardApiModel} from './share-card.api-model';

export class PostApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public type: string;
  @Expose() public heading: string;
  @Expose() public content: string;
  @Expose() public comments: string[];
  @Expose() public commentsCount?: number;
  @Type(() => ReactionApiModel)
  public reactions: (ReactionApiModel | string)[];
  @Expose() public reactionsCount?: number;
  @Expose() public sharesCount?: number;
  @Expose()
  @Type(() => ReactionApiModel)
  public reactionsPreview?: (ReactionApiModel | string)[];
  @Expose()
  @Type(() => ReactionApiModel)
  public currentUserReaction?: ReactionApiModel | null;
  @Expose() public startDate?: Date;
  @Expose() public endDate?: Date;
  @Expose() public entryType?: string;
  @Expose() public readonly?: boolean;
  @Expose()
  @Type(() => MediaObjectApiModel)
  public media: (MediaObjectApiModel | string)[];
  @Expose()
  @Type(() => UserApiModel)
  public postedBy: UserApiModel;
  @Expose() public project: (string|ProjectApiModel);
  @Expose() public event: (string|EventApiModel);
  @Expose() public collaboration: (string|ProjectCollaborationApiModel);
  @Expose() public createHistoryEntryOnApproval?: boolean;
  @Expose() public historyEntryContent?: string;
  @Expose() public historyPost?: string | PostApiModel;
  @Expose() public updatedAt: Date;
  @Expose() public createdAt: Date;
  @Expose() public featuredAt: Date;
  @Expose() public processingStatus?: 'pending' | 'processing' | 'partially_completed' | 'completed' | 'failed';
  @Expose() public processingUpdatedAt?: Date;
  @Expose() public shareType?: string | null;
  @Expose() public shareId?: string | null;
  @Expose()
  @Type(() => ShareRefApiModel)
  public shareRef?: ShareRefApiModel | null;
  @Expose()
  @Type(() => ShareCardApiModel)
  public shareCard?: ShareCardApiModel | null;
}
